module.exports = __webpack_public_path__ + "473ee081160a469c95199d70e78f55fa.png";